

















































































































































import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import {
  faEnvelope,
  faHeadset,
  faPhone
} from '@fortawesome/free-solid-svg-icons'
import InfoContact from '~/components/car/information/InfoContactForm.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { UserType } from '~/models/user/types'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { ciInfo } from '~/icons/source/solid/info'
import { ciCalculator } from '~/icons/source/solid/calculator'
import { APP_NS } from '~/store/modules/shared/app/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { defineComponentTranslations } from '~/utils/i18n'

export default Vue.extend({
  components: {
    InfoContact,
    CCard
  },
  data() {
    return {
      telephones: []
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userType: 'type'
    }),
    ...mapGetters(APP_NS, {
      isCar: 'isCar',
      isPlot: 'isPlot'
    }),
    ...mapDeps({ legacyUrlService: LegacyUrlService }),
    isAnon() {
      return this.userType === UserType.ANON
    },
    isGuest() {
      return this.userType === UserType.GUEST
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('information')
        },
        {
          text: this.$t('support')
        }
      ]
    },
    icons() {
      return {
        email: faEnvelope,
        phone: faPhone,
        question: faHeadset,
        ciInfo,
        ciCalculator
      }
    }
  },
  mounted() {
    if (this.isPlot) {
      return
    }

    this.$axios
      .get('/api/information/telephones/')
      .then(response => {
        this.telephones = response.data.data.telephones
      })
      .catch(error => {
        this.isLoading = false
        this.onResponseError(error, error.response.status)
      })
  },
  head() {
    return {
      title: `${this.$t('support')} - ${this.$t('contact')}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('contact_description', {
            appName: this.isCar ? 'Car.gr' : 'Plot.gr'
          })
        }
      ]
    }
  },
  i18n: defineComponentTranslations({
    do_not_call_these_phones_car: {
      en:
        '<strong>Do not call</strong> these phones if you are looking for vehicles or parts. Car.gr is a website that <strong>hosts</strong> classifieds. <a href="/quick-search">Click here</a> to search what you want (and call the phone that\'s in the classified).',
      el:
        '<strong>Μην παίρνετε</strong> σε αυτά τα τηλέφωνα εάν ψάχνετε για όχημα ή ανταλλακτικά. Το Car.gr <strong>φιλοξενεί</strong> απλά τις αγγελίες. <a href="/quick-search/">Πατήστε εδώ</a> για να αναζητήσετε αυτό που θέλετε (και καλέστε το τηλέφωνο που είναι στην αγγελία).'
    },
    do_not_call_these_phones_plot: {
      en:
        'Do not call these phones If you\'re seeking information about a classified. Το Plot.gr is the website that hosts classifieds. <a href="/search"> Click here </a> to search what you want (and call the phone that\'s in the classified).',
      el:
        'Μην καλείτε σε αυτά τα τηλέφωνα εάν ψάχνετε πληροφορίες για κάποια αγγελία. Το Plot.gr φιλοξενεί απλώς τις αγγελίες. <a href="/search">Πατήστε εδώ</a> για να αναζητήσετε αυτό που θέλετε (και καλέστε το τηλέφωνο που βρίσκεται στην κάθε αγγελία).'
    },
    contact_description: {
      en: 'Contact {appName} if you are facing a problem or have a question.',
      el:
        'Επικοινώνησε με το {appName} αν αντιμετωπίζεις κάποιο πρόβλημα ή έχεις κάποια απορία.'
    }
  })
})
